import { EExportFileType } from "@rentiohq/shared-frontend/dist/reduxV2/exportFile";
import { EScheduledExportFrequency } from "@rentiohq/shared-frontend/dist/reduxV2/scheduledExport";
import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.createCustomExport.1";
import {
  EField,
  FREQUENCY_ONCE,
  IExtraData,
} from "./schema.createCustomExport.types";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = {
    [EField.ExportType]: extraData.exportTypes[0],
    [EField.ExportFileType]: EExportFileType.Xlsx,
    [EField.Frequency]:
      extraData.isRecurring && extraData.canSchedule
        ? EScheduledExportFrequency.Monthly
        : FREQUENCY_ONCE,
    [EField.RunWeekday]: 1,
    [EField.RunMonth]: 1,
    [EField.RunDayOfMonth]: 1,
  };

  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
